import React from 'react';
import styles from './styles';
import {WindowDisplay, Loader} from '@xpertdox_js/xdcomponents';
// General/Context
// hooks
import { fetchPatient, updatePatient } from './Hooks/fetchers';
import getWindows from './Hooks/windowSettings';
import {UserContext} from "../../Context/UserContext";

const PatientOverview = props => {

  // -- var deps
  const {id, instance, user, overviewData, setOverviewData, diffState, setDiff, diffRef, windowDisplayDims, filters, cache} = props.deps;

  // -- trackers store
  const fetchedList = React.useRef({patient: !!overviewData})
  const setHasFetched = (property, value) => fetchedList.current[property] = value;
  const hasFetched = fetchedList.current;
  const { userAction } = React.useContext(UserContext);
  const lastID = React.useRef(id);
  // -- Request Handlers
  if (lastID.current !== id) {
    setHasFetched('patient', false);
    lastID.current = id;
  }
  // fetch trial
  if (!hasFetched.patient) {
    setHasFetched('patient', true);
    fetchPatient(id, instance, user.email).then(data => {
      setOverviewData(data)
    })
  }

  // save patient
  const handleSave = async () => {
    try {
      await updatePatient(id, instance, user.email, overviewData, diffState);
      setHasFetched('patient', false);
      props.deps.removeFromCache(id);
    } catch(err) {
      console.error(err)
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    }
  }

  const returnCacheList = (key) => {
    let ids = [];
    let formattedKey = 'all'
    if (key) {
      let k = key.replaceAll('%20', '')
      if(k === 'PatientContacted') formattedKey = 'patientContacted'
      else if(k === 'Inbox') formattedKey = 'inbox'
      else if(k === 'StudyTeamContacted') formattedKey = 'piContacted'
      else if(k === 'PreScreenPass') formattedKey = 'preScreenPass'
      else if(k === 'Final') formattedKey = 'final'
      else if(k === 'All') formattedKey = 'all'
      let cacheKey = `xpertTriage_po_${formattedKey}`
      if(cache[cacheKey] && cache[cacheKey].data) ids = cache[cacheKey].data.map(i => i._id)
    }
    return ids
  }

  // -- get windows for window display
  let allNctsToPass = props.location.state ? returnCacheList(props.location.state.activeFetchParam) :  [];
  const patientWindows = overviewData
    ? getWindows({handleSave, diffRef, setDiff, user, filters, id, overviewData, allNctsToPass, match: props.match, history: props.history})
    : null;

  return(overviewData && Object.keys(filters).length !== 0
    ? <WindowDisplay
      key={id}
      styles={{
        container: {...windowDisplayDims, maxHeight: windowDisplayDims.height},
      }}
      settings={{
        windows: 2,
        initial: ['patientInformation', 'studyDetails'],
        windowSettings: patientWindows,
      }}
    />
   : <Loader
       styles={styles.loaderStyles}
       width='132px'
       height='132px'
       noBg
     />
  )
}

export default PatientOverview;
